<template>
  <el-row :gutter="40">
    <el-col :span="11">
      <div class="media-img">
        <media-view
          width="100%"
          height="100%"
          :mediaClassId="mediaModel.mediaClassId"
          :src="mediaModel.mediaIcon"
          :previewSrc="mediaModel.mp4Url"
        ></media-view>
      </div>
    </el-col>
    <el-col :span="13">
      <el-form label-width="100px" label-position="left" style="margin-top: -10px">
        <el-form-item label="所属订单">{{ mediaModel.orderName }}</el-form-item>
        <el-form-item label="所属计划">{{ mediaModel.scheduleName }}</el-form-item>
        <el-form-item label="广告主">{{ mediaModel.partnerName }}</el-form-item>
        <el-form-item label="广告位">{{ mediaModel.adSpaceName }}</el-form-item>
        <el-form-item label="素材类型">{{ mediaModel.adMediaClass ? mediaModel.adMediaClass.mediaClassName : '' }}</el-form-item>
        <el-form-item v-if="mediaModel.mateCheckCode" label="物料校验码">{{ mediaModel.mateCheckCode }}</el-form-item>
        <el-form-item label="显示时长">{{ mediaModel.duration }} s</el-form-item>
        <el-form-item v-if="mediaModel.locationType" label="显示位置">{{ locationTypeObj[mediaModel.locationType] }}</el-form-item>
        <el-form-item v-if="mediaModel.locationType && mediaModel.locationType === 10" label="X轴">{{ mediaModel.coordinateX }} px</el-form-item>
        <el-form-item v-if="mediaModel.locationType && mediaModel.locationType === 10" label="Y轴">{{ mediaModel.coordinateY }} px</el-form-item>
        <el-form-item v-if="mediaModel.effect" label="动画效果">{{ effectObj[mediaModel.effect] }}</el-form-item>
        <el-form-item v-if="mediaModel.landingPage" label="落地页">{{ mediaModel.landingPage }}</el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
import { locationTypeObj, effectObj } from '@/views/advertisement/creative/MaterialCreative'

export default {
  props: {
    mediaModel: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      locationTypeObj,
      effectObj,
    }
  },
}
</script>

<style lang="stylus" scoped>
.el-form-item
  margin-bottom 0
</style>
